import { deepOmit } from "./functional";

export const removeTypenameRedacted = <T extends {}>(response: T) => {
  return deepOmit(
    response,
    (key: any) => key === "__typename" || key === "redacted"
  );
};
